// extracted by mini-css-extract-plugin
export var landscape = "ImageWidget-module--landscape--03197";
export var portrait = "ImageWidget-module--portrait--1d351";